<script lang="ts">
  import { Container, Row } from "sveltestrap";
  import BookmarkTasks from "./BookmarkTasks.svelte";
  import TasksTab from "./TasksTab.svelte";
  import TasksContent from "./TasksContent.svelte";
</script>

<BookmarkTasks />
<Container fluid>
  <div class="email-wrap bookmark-wrap">
    <Row>
      <TasksTab />
      <TasksContent />
    </Row>
  </div>
</Container>
